import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucFilm: FC<IconType> = ({ iconColor = 'currentColor', ...svgProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <g clip-path='url(#clip0_2421_12879)'>
        <path
          d='M10.7358 1.08331H2.26409C1.61193 1.08331 1.08325 1.61199 1.08325 2.26415V10.7358C1.08325 11.388 1.61193 11.9166 2.26409 11.9166H10.7358C11.3879 11.9166 11.9166 11.388 11.9166 10.7358V2.26415C11.9166 1.61199 11.3879 1.08331 10.7358 1.08331Z'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.79175 1.08331V11.9166'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.20825 1.08331V11.9166'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.08325 6.5H11.9166'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.08325 3.79169H3.79159'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.08325 9.20831H3.79159'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.20825 9.20831H11.9166'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.20825 3.79169H11.9166'
          stroke={iconColor}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2421_12879'>
          <rect width='13' height='13' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NucFilm
